module.exports = __webpack_public_path__ + "img/1.9a309bc6.png";